import { Configuration } from "../types";
import { ConfigurationActions } from "./action_types"
import { Action } from "./actions"

const configurationReducer = (state: any, action: Action): any => {
  switch (action.type) {
    case ConfigurationActions.CREATE:
      return {
        ...state,
        configurations: [...state.configurations, action.payload]
      }

    case ConfigurationActions.UPDATE:
      const updatedConfigurations = state.configurations.map((config: Configuration) => {
        if (config.id === action.payload.id) { 
          return action.payload 
        } else { 
          return {
            ...config,
            is_default: action.payload.is_default ? false : config.is_default,
            is_display_tablet_rooftop: action.payload.is_display_tablet_rooftop ? false : config.is_display_tablet_rooftop
          }
        }
      });
      return {
        ...state,
        configuration: action.payload,
        configurations: updatedConfigurations
      };

    case ConfigurationActions.GET:
      return {
        ...state,
        configuration: action.payload
      }

    case ConfigurationActions.GET_ALL:
      return {
        ...state,
        configurations: action.payload
      }

    case ConfigurationActions.DELETE:
      return {
        ...state,
        configurations: [...state.configurations.filter((config: any) => config.id !== action.payload.id)]
      }
      
    default:
      return {
        ...state,
      }
  }
}

export default configurationReducer
